module.exports = __webpack_public_path__ + "img/Gallery_2_03.837cd033.jpeg";